import { createColumnHelper } from '@tanstack/react-table';
import { TPriceBandAndRules } from './types';
import { IPriceBandWithVenues } from 'src/types/priceBand.types';
import { PriceBandRuleSteps } from '../PriceBandRuleModal/PriceBandRuleModalContent';
import {
  Bin,
  CalculationIcon,
  EllipsisMenu,
  LinkButton,
  RoundingIcon,
  TextIcon,
  VenueIcon,
} from '@weareopenr/component-library';
import { CREATE_PRICE_BAND } from '../PriceSchemeChannelRulesTab/constants';

import styles from './PriceSchemeBandsRulesTab.module.scss';
import { sharedTableColumns } from 'src/utils/priceRules/tableColumns';

export const columnHelper = createColumnHelper<TPriceBandAndRules>();

type TTableColumnsHelper = {
  setModalOpen: () => void;
  handleEdit: (id: IPriceBandWithVenues, step: PriceBandRuleSteps) => void;
  handleDelete?: (id: IPriceBandWithVenues) => void;
};

export const getPriceBandTableColumms = ({ setModalOpen, handleEdit, handleDelete }: TTableColumnsHelper) => [
  columnHelper.accessor('name', {
    header: 'Price Band',
    size: 200,
    footer: () => {
      return (
        <LinkButton onClick={setModalOpen} type="button">
          {CREATE_PRICE_BAND}
        </LinkButton>
      );
    },
  }),
  columnHelper.accessor('venues', {
    header: 'Venues',
    cell: ({ row }) => row.original.venues.length,
  }),
  ...sharedTableColumns<TPriceBandAndRules>(),
  columnHelper.display({
    id: 'action',
    size: 80,
    cell: ({ row }) => {
      if (!row.original.priceBandId) {
        return null;
      }

      return (
        <div className={styles['ellipsis-menu-container']}>
          <EllipsisMenu
            options={[
              {
                id: 'edit-name',
                name: 'Edit Name',
                icon: TextIcon,
                onOptionClick: () => handleEdit(row.original, PriceBandRuleSteps.Name),
              },
              {
                id: 'edit-venues',
                name: 'Edit Venue Allocation',
                icon: VenueIcon,
                onOptionClick: () => handleEdit(row.original, PriceBandRuleSteps.Venues),
              },
              {
                id: 'edit-calculation',
                name: 'Edit Calculation',
                icon: CalculationIcon,
                onOptionClick: () => handleEdit(row.original, PriceBandRuleSteps.Adjustment),
              },
              {
                id: 'edit-rounding',
                name: 'Edit Rounding',
                icon: RoundingIcon,
                onOptionClick: () => handleEdit(row.original, PriceBandRuleSteps.Rounding),
              },
              { id: 'delete-divider', isDivider: true },
              {
                id: 'delete',
                name: 'Delete Price Band',
                icon: Bin,
                onOptionClick: () => handleDelete(row.original),
                hoverColour: 'tomato',
              },
            ]}
            variant="ghost"
            hoverStyle="high-contrast"
          />
        </div>
      );
    },
  }),
];
